import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/PageHeader";
import { ProfilesTab } from "@/components/admin/ProfilesTab";
import { UsersTab } from "@/components/admin/UsersTab";
import { BrandingTab } from "@/components/admin/BrandingTab";
import { MsgLedgerTab } from "@/components/admin/MsgLedgerTab";
import { EmbedTab } from "@/components/admin/EmbedTab";

export default function SuperAdmin() {
  return (
    <div>
      <PageHeader title="SuperAdmin" subtitle="Profili di accesso, utenti e landing page personalizzata" />
      <Tabs defaultValue="profiles">
        <TabsList className="mb-6">
          <TabsTrigger value="profiles" data-testid="admin-tab-profiles">Profili di accesso</TabsTrigger>
          <TabsTrigger value="users" data-testid="admin-tab-users">Utenti</TabsTrigger>
          <TabsTrigger value="branding" data-testid="admin-tab-branding">Landing page</TabsTrigger>
          <TabsTrigger value="ledger" data-testid="admin-tab-ledger">Contabilità messaggi</TabsTrigger>
          <TabsTrigger value="embed" data-testid="admin-tab-embed">Integrazione iframe</TabsTrigger>
        </TabsList>
        <TabsContent value="profiles"><ProfilesTab /></TabsContent>
        <TabsContent value="users"><UsersTab /></TabsContent>
        <TabsContent value="branding"><BrandingTab /></TabsContent>
        <TabsContent value="ledger"><MsgLedgerTab /></TabsContent>
        <TabsContent value="embed"><EmbedTab /></TabsContent>
      </Tabs>
    </div>
  );
}
